import { colorsPalette, muiFocusVisibleOutlineMixin, styled } from '../theme';
import { Button, type ButtonProps } from './Button';
import type { PropsWithChildren } from 'react';

interface OptionButtonProps extends InheritedButtonProps {
    selected?: boolean;
}

type InheritedButtonProps = Pick<ButtonProps, 'onClick' | 'labelFullWidth' | 'sx' | 'disabled'>;

export const OptionButton = (props: PropsWithChildren<OptionButtonProps>) => (
    <ButtonStyled disableRipple {...props} />
);

const ButtonStyled = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'selected',
})<OptionButtonProps>(({ theme, selected }) => ({
    border: `${theme.borderWidth}px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    color: 'inherit',
    ...muiFocusVisibleOutlineMixin(theme),
    ':hover': {
        color: 'inherit',
        borderColor: colorsPalette.primaryAlpha[20],
        backgroundColor: colorsPalette.primaryAlpha[8],
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'inherit',
        },
    },
    ...(selected && {
        borderColor: theme.palette.primary.main,
        backgroundColor: colorsPalette.primaryAlpha[16],

        ':hover': {
            borderColor: theme.palette.primary.main,
            backgroundColor: colorsPalette.primaryAlpha[8],
            [theme.breakpoints.down('sm')]: {
                backgroundColor: colorsPalette.primaryAlpha[16],
            },
        },
    }),
}));
